// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1cJUP","colMin":"styles_colMin__2XHQO","colCheckbox":"styles_colCheckbox__2_-L8"};